export const AUTH_REQUEST = "AUTH_REQUEST";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_ERROR = "AUTH_ERROR";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTO_LOGIN = "AUTO_LOGIN";
export const AUTH_GOOGLE_REQUEST = "AUTH_GOOGLE_REQUEST"
